import { ImageTemplate } from "../template";
import { ImageProps } from "..";
import ParachuteLogo1x from "./parachute-logo-1x.png";
import ParachuteLogo2x from "./parachute-logo-2x.png";
import ParachuteLogo4x from "./parachute-logo-4x.png";

export const ParachuteLogoImage = ({
  width,
  height,
  highResolution,
  ...props
}: ImageProps): JSX.Element => {
  return (
    <div style={{ height, width }}>
      <ImageTemplate
        {...props}
        imgSrc={ParachuteLogo4x}
      />
    </div>
  );
};
